import React from 'react';
import { trustStrip } from '../../data/site';
export function TrustStrip() {
  return <section aria-label="Format, delivery and payment" className="border-y border-line bg-mint text-ink" data-id="element-584" data-mp="2sld70nosxmyh">
      <ul className="mx-auto grid max-w-page grid-cols-2 border-x border-line lg:grid-cols-4" data-id="element-585" data-mp="2xkgai3p4vl4c">
        {trustStrip.map((item, index) => <li key={item.label} className={`flex flex-col items-center justify-center px-3 py-7 text-center sm:py-9 ${index % 2 === 1 ? 'border-l border-line' : ''} ${index > 1 ? 'border-t border-line lg:border-t-0' : ''} ${index === 2 ? 'lg:border-l' : ''}`} data-id="element-586" data-mp="31nw8b3cxvrim" data-mpi={index}>
            <span className="font-display text-[34px] font-bold uppercase leading-none text-gold-dark sm:text-[46px]" data-id="element-587" data-mp="3gdtqn2o6tmzw">
              {item.value}
            </span>
            <span className="mt-2 text-[12px] font-bold uppercase tracking-[0.14em] text-body sm:text-[13px]" data-id="element-588" data-mp="3pdqkdipfpc1t">
              {item.label}
            </span>
          </li>)}
      </ul>
    </section>;
}